module.exports = __webpack_public_path__ + "static/media/tga.4173b316.svg";